import React from 'react';
import './ndoeUi.css';

/**
 * NdoePage — wrapper de page (fond ivoire, padding fluide, place pour CTA sticky).
 * Enveloppe le contenu d'une page du parcours commerce/logistique.
 *
 * Props :
 *  - children
 *  - className : classes additionnelles
 *  - ...rest : passé au <div>
 */
export default function NdoePage({ children, className = '', ...rest }) {
  return (
    <div className={`ndoe-page ${className}`} {...rest}>
      {children}
    </div>
  );
}
